<marv-select 
    [label]="this.labelSelect" 
    [icon]="this.iconSelect" 
    [formName]="this.formName" 
    [items]="this.items" 
    [itemsSelected]="this.itemsSelected" 
    [externalSource]="this.externalSource"
    [multiple]="this.multiple"
    [displayItemsSelected]="this.displayItemsSelected"
    [errorText]="this.errorText"
    [withSpeechToText]="this.withSpeechToText"
></marv-select>